import { Box, Divider } from "@mui/material";
import React from "react";
import { Captain } from "../../../types/Captain";
import ScrollAnimationWrapper from "../../layouts/Animations/ScrollAnimationWrapper";
import SectionTitle from "../../layouts/SectionTitle/SectionTitle";
import KeyDetailsItem from "./KeyDetailsItem";
import { customDivider } from "./keyDetailsItemStyles";
import { keyDetailsContainer } from "./keyDetailsStyles";

interface KeyDetailsProps {
    details: Captain["keyDetails"];
}

const KeyDetails: React.FC<KeyDetailsProps> = ({ details }) => {
    return (
        <Box sx={keyDetailsContainer}>
            <SectionTitle>INFO</SectionTitle>

            {details?.map((detail, index) => (
                <React.Fragment key={index}>
                    <ScrollAnimationWrapper>
                        <KeyDetailsItem
                            label={detail.label}
                            value={detail.value}
                        />
                    </ScrollAnimationWrapper>
                    {index < details.length - 1 && (
                        <Divider sx={customDivider} />
                    )}
                </React.Fragment>
            ))}
        </Box>
    );
};

export default KeyDetails;
